import {
  useBrokersServiceBrokersTeamsDestroy,
  useBrokersServiceBrokersTeamsListKey
} from '@insurance/api/queries'
import { showApiErrors } from '@shared/utils'
import { useQueryClient } from '@tanstack/react-query'
import { App, Modal } from 'antd'
import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'

import { CommonPropsTeam } from './types'

export const DeleteTeam = ({
  data,
  onSuccess,
  open,
  onCancel
}: CommonPropsTeam) => {
  const { t } = useTranslation()
  const [modal, contextHolder] = Modal.useModal()
  const { message } = App.useApp()
  const queryClient = useQueryClient()

  const { mutateAsync: deleteMutation } = useBrokersServiceBrokersTeamsDestroy({
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [useBrokersServiceBrokersTeamsListKey]
      })

      message.success(t('removed_successfully'))

      onSuccess()
    },
    onError: (error) => showApiErrors(error)
  })

  useEffect(() => {
    const id = data?.id
    if (!id) return

    const { destroy } = modal.confirm({
      title: t('delete_confirm'),
      content: (
        <span
          dangerouslySetInnerHTML={{
            __html: t('delete_confirm_description_team', {
              name: data.name
            })
          }}
        />
      ),
      okText: t('delete'),
      cancelText: t('cancel'),
      okType: 'danger',
      onOk: () => deleteMutation({ id }),
      open,
      onCancel
    })

    return destroy
  }, [data, deleteMutation, modal, onCancel, open, t])

  return contextHolder
}
